import React from 'react';
import UsedCarsForm from './UsedCarsForm';
import UsedCarsEdaPage from './UsedCarsEdaPage';
import './UsedCarsPage.css';

const UsedCarsPage: React.FC = () => {
  return (
    <div className="page-container">
      <h1>Used Cars Price Predictor</h1>
      <p>
        This tool uses a machine learning model to predict the price of a used car based on its
        characteristics. Fill out the form below with the details of the car you're interested in,
        and we'll provide an estimated price.
      </p>
      <UsedCarsForm />

      <div className="used-cars-analysis">
        <h3>Used Cars Analysis</h3>
        <UsedCarsEdaPage />
      </div>
    </div>
  );
};

export default UsedCarsPage;
